import initialState from '../../../store/initialState';
import EnfermedadPreexistenteTipos from './EnfermedadPreexistenteTipos';

const formatoDeEnfermedades = (lista) =>{
    const listaretorno=[];
    if(lista.length && lista.length>=1){
        // listaretorno.push({ value: 'ninguna', label: 'Ninguna', disable: false });
        for (let index = 0; index < lista.length; index += 1) {
            listaretorno.push({ value: Number(lista[index].id), label: `${lista[index].nombre}`, disable: false });
          }
    }
    return listaretorno;
}

const obternerEnfermedadesPreExistentes = (state = initialState.enfermedadPreexistente.data, action) => {
    switch (action.type) {
        case EnfermedadPreexistenteTipos.data.OBTENER_ENFERMEDADES_PRE_EXISTENTES_PENDIENTE:
            return ({
                ...state,
                enEjecucionAPIEnfermedadesPreExistentes: action.payload.enEjecucionAPIEnfermedadesPreExistentes
            });
        case EnfermedadPreexistenteTipos.data.OBTENER_ENFERMEDADES_PRE_EXISTENTES_EXITO:
            return ({
                ...state,
                enEjecucionAPIEnfermedadesPreExistentes: false,
                listaDeEnfermedadesApi: action.payload.lista,
                listaFormatoLabel: formatoDeEnfermedades(action.payload.lista)
            });
        case EnfermedadPreexistenteTipos.data.INGRESAR_ENFERMEDAD:
            return ({
                ...state,
                enfermedades: action.payload.tieneEnfermedadPreexistente,
                // enfermedadesSeleccionadas: action.payload.tieneEnfermedadPreexistente
            });
        case EnfermedadPreexistenteTipos.data.INGRESAR_ENFERMEDAD_SOCIO:
            return ({
                ...state,
                enfermedadesSeleccionadas: action.payload.tieneEnfermedadPreexistente
            });
        case EnfermedadPreexistenteTipos.data.ERROR:
            return ({
                ...state,
                errorApi: action.payload.error
            });
        default:
            return state;
    }
}

export default obternerEnfermedadesPreExistentes;
